import MetricsProvider from "./MetricsProvider";

export default class Amplitude extends MetricsProvider {
  appId;

  constructor(appId) {
    super();
    this.appId = appId;
  }

  identify(userIdentity, userProps) {
    const identity = new amplitude.Identify()
    identity.set("user", userIdentity);
    //keeps the data flat so you do have to query on "user.fieldname"
    Object.entries(userProps).forEach(entry => {
      const [key, value] = entry;
      identity.set(key, value);
    });
    amplitude.getInstance().identify(identity);
  }

  install = async () => {
    return import("./amplitude.installer").then(() => {
      amplitude.getInstance().init(this.appId);
    })
  }
  recordEvent(name, properties) {
    amplitude.getInstance().logEvent(name, properties);
  }
}
